import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./../api/request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { CommonService } from "../api";

@Injectable({
  providedIn: "root",
})
export class PatientA2ZService {
  protected environment: any;
  constructor(
    @Inject('AppEnvironment') environmentConfig,
    private request: Request,
    private http: HttpClient,
    private _commonService: CommonService,
  ) {
    this.environment = environmentConfig;
  }

  getPatientsList(event): Observable<any> {


    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }



    let url = URLS.x_a2z_apis.getPatientsList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction + '&type=' + event.type;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }

  getAllPatientsList(): Observable<any> {

    let url = URLS.patient.getPatientsFullList;
    return this.request.getApi(url);
  }

  getAutoCompletePatientsList(val): Observable<any> {

    let url = URLS.patient.getPatientsFullList + '?searchkey=' + val;
    return this.request.getApi(url);
  }
  savePatients(values): Observable<any> {
    let url = URLS.x_a2z_apis.createPatients;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.postApi(url, values);
  }

  editPatients(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.patientsUpdate;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deletePatients(data): Observable<any> {
    let url = URLS.x_a2z_apis.patientsDelete;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getPatientsInfo(id, type?: string): Observable<any> {
    let url = URLS.x_a2z_apis.patientFetch + '?type=' + type;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }




  getUsersList(event): Observable<any> {

    if (event.direction == 'desc') {
      event.direction = 2;
    }
    else {
      event.direction = 1;
    }

    let url = URLS.x_a2z_apis.getUsersList + '?limit=' + event.pageSize + '&page=' + (event.pageIndex + 1) + '&searchkey=' + event.filterValue + '&order_by=' + event.active + '&dir=' + event.direction + '&role=' + event.role;

    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);

  }

  saveUsers(values): Observable<any> {
    let url = URLS.x_a2z_apis.createUsers;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.postApi(url, values);
  }

  editUsers(id, values): Observable<any> {
    let url = URLS.x_a2z_apis.usersUpdate;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteUsers(data): Observable<any> {
    let url = URLS.x_a2z_apis.usersDelete;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getUsersInfo(id, type?: string): Observable<any> {
    let url = URLS.x_a2z_apis.userFetch + '?type=' + type;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }


}
